import { addDays, endOfToday, startOfToday, subDays } from 'date-fns';

export const FILTER_VALUES = {
  PAST: 'past',
  FUTURE: 'future',
};

export const TIME_RANGES = {
  NONE: 'none',
  TODAY: 'today',
  TOMORROW: 'tomorrow',
  NEXT_7_DAYS: 'next7days',
  NEXT_30_DAYS: 'next30days',
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last7days',
  LAST_30_DAYS: 'last30days',
};

export const TIME_RANGE_VALUES = {
  [TIME_RANGES.NONE]: [],
  [TIME_RANGES.TODAY]: [startOfToday(), endOfToday()],
  [TIME_RANGES.TOMORROW]: [addDays(startOfToday(), 1), addDays(endOfToday(), 1)],
  [TIME_RANGES.NEXT_7_DAYS]: [startOfToday(), addDays(endOfToday(), 7)],
  [TIME_RANGES.NEXT_30_DAYS]: [startOfToday(), addDays(endOfToday(), 30)],
  [TIME_RANGES.YESTERDAY]: [subDays(startOfToday(), 1), subDays(endOfToday(), 1)],
  [TIME_RANGES.LAST_7_DAYS]: [subDays(endOfToday(), 7), startOfToday()],
  [TIME_RANGES.LAST_30_DAYS]: [subDays(endOfToday(), 30), startOfToday()],
};

export const TIME_RANGES_FUTURE = [
  TIME_RANGES.NONE,
  TIME_RANGES.TODAY,
  TIME_RANGES.TOMORROW,
  TIME_RANGES.NEXT_7_DAYS,
  TIME_RANGES.NEXT_30_DAYS,
];

export const TIME_RANGES_PAST = [
  TIME_RANGES.NONE,
  TIME_RANGES.TODAY,
  TIME_RANGES.YESTERDAY,
  TIME_RANGES.LAST_7_DAYS,
  TIME_RANGES.LAST_30_DAYS,
];
